/* The waterline: a solid surface line with a dashed reflection under it.
   Used under the hero loon and as the divider between sections. The dash
   group drifts slowly unless the visitor prefers reduced motion. */

export function Waterline({ hero = false }: { hero?: boolean }) {
  return (
    <svg
      className={hero ? 'waterline waterline--hero' : 'waterline'}
      viewBox="0 0 1200 18"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <line x1="0" y1="1" x2="1200" y2="1" stroke="currentColor" strokeWidth="1.5" />
      <g className="ripple" stroke="currentColor" strokeWidth="1" opacity="0.55">
        <line x1="80" y1="8" x2="150" y2="8" />
        <line x1="300" y1="13" x2="345" y2="13" />
        <line x1="520" y1="7" x2="610" y2="7" />
        <line x1="760" y1="12" x2="815" y2="12" />
        <line x1="980" y1="8" x2="1060" y2="8" />
      </g>
    </svg>
  )
}
